import addresses from 'data/addresses';
import { ethers } from 'ethers';
import { useEffect, useMemo, useState } from 'react';
import { useWallet } from './useWallet';
import omnichain from 'data/abi/omnichain.json';
import chains from 'data/chains';

const useContract = () => {
  const { signer, chainId, chainSupported } = useWallet();

  const [contract, setContract] = useState(null);

  useEffect(() => {
    if (!signer || !chainId || !chainSupported) return;

    console.log(chainId);
    console.log(chains[chainId].name);
    console.log(addresses[chains[chainId].name]);
    setContract(new ethers.Contract(addresses[chains[chainId].name], omnichain, signer));
  }, [chainId, signer, chainSupported]);

  return useMemo(() => contract, [contract]);
};

export default useContract;
